import { Shield, Wifi, Server, Cpu, Globe, Lock } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const COUNTRIES = [
  { name: "United States", cyber: 95, infra: 92, comms: 94, defense: 98, overall: 95 },
  { name: "Israel", cyber: 93, infra: 88, comms: 91, defense: 96, overall: 92 },
  { name: "United Kingdom", cyber: 90, infra: 87, comms: 89, defense: 88, overall: 89 },
  { name: "China", cyber: 88, infra: 85, comms: 82, defense: 90, overall: 86 },
  { name: "Russia", cyber: 82, infra: 68, comms: 70, defense: 85, overall: 76 },
  { name: "India", cyber: 72, infra: 60, comms: 65, defense: 75, overall: 68 },
  { name: "Iran", cyber: 65, infra: 52, comms: 55, defense: 72, overall: 61 },
  { name: "Ukraine", cyber: 70, infra: 45, comms: 58, defense: 68, overall: 60 },
  { name: "Saudi Arabia", cyber: 68, infra: 75, comms: 72, defense: 70, overall: 71 },
  { name: "Taiwan", cyber: 85, infra: 90, comms: 88, defense: 78, overall: 85 },
  { name: "South Korea", cyber: 88, infra: 91, comms: 90, defense: 82, overall: 88 },
  { name: "Turkey", cyber: 65, infra: 62, comms: 64, defense: 72, overall: 66 },
];

const getColor = (v: number) => (v >= 85 ? "text-green-400" : v >= 65 ? "text-yellow-400" : "text-red-400");
const getBg = (v: number) => (v >= 85 ? "bg-green-500" : v >= 65 ? "bg-yellow-500" : "bg-red-500");

const TechReadinessIndex = () => (
  <section id="tech-readiness" className="py-8">
    <div className="container mx-auto px-4">
      <div className="mb-6 flex items-center gap-3">
        <Cpu className="h-5 w-5 text-primary" />
        <h2 className="font-mono text-lg font-bold uppercase tracking-wider text-foreground">
          Tech & Cyber Readiness Index
        </h2>
        <Badge variant="outline" className="text-[8px] font-mono border-primary/30 text-primary">COMPOSITE</Badge>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-xs font-mono">
          <thead>
            <tr className="border-b border-border text-[9px] text-muted-foreground uppercase">
              <th className="text-left py-2 pr-4">Country</th>
              <th className="text-center py-2 px-2"><Lock className="h-3 w-3 mx-auto mb-0.5" />Cyber</th>
              <th className="text-center py-2 px-2"><Server className="h-3 w-3 mx-auto mb-0.5" />Infra</th>
              <th className="text-center py-2 px-2"><Wifi className="h-3 w-3 mx-auto mb-0.5" />Comms</th>
              <th className="text-center py-2 px-2"><Shield className="h-3 w-3 mx-auto mb-0.5" />Defense</th>
              <th className="text-center py-2 px-2"><Globe className="h-3 w-3 mx-auto mb-0.5" />Overall</th>
              <th className="py-2 px-2 w-32"></th>
            </tr>
          </thead>
          <tbody>
            {COUNTRIES.sort((a, b) => b.overall - a.overall).map((c) => (
              <tr key={c.name} className="border-b border-border/50 hover:bg-accent/30 transition-colors">
                <td className="py-2 pr-4 text-foreground font-medium">{c.name}</td>
                <td className={`text-center py-2 px-2 ${getColor(c.cyber)}`}>{c.cyber}</td>
                <td className={`text-center py-2 px-2 ${getColor(c.infra)}`}>{c.infra}</td>
                <td className={`text-center py-2 px-2 ${getColor(c.comms)}`}>{c.comms}</td>
                <td className={`text-center py-2 px-2 ${getColor(c.defense)}`}>{c.defense}</td>
                <td className={`text-center py-2 px-2 font-bold ${getColor(c.overall)}`}>{c.overall}</td>
                <td className="py-2 px-2">
                  <div className="h-1.5 rounded-full bg-secondary overflow-hidden">
                    <div className={`h-full rounded-full ${getBg(c.overall)}`} style={{ width: `${c.overall}%` }} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-[9px] text-muted-foreground font-mono">
        Composite index based on ITU Global Cybersecurity Index, WEF Global Competitiveness, and SIPRI defense data.
      </p>
    </div>
  </section>
);

export default TechReadinessIndex;
